/** ZEUS and its voting wrapper wZEUS: contracts and amounts. No network, no wallet, no React. */

export const ZEUS_ADDRESS = '0x0f7dc5d02cc1e1f5ee47854d534d332a1081ccc8' as const;
export const WZEUS_ADDRESS = '0xA56B06AA7Bfa6cbaD8A0b5161ca052d86a5D88E9' as const;
export const TALLY_URL = 'https://www.tally.xyz/gov/zeus-cc8-community-takeover';
export const WZEUS_ETHERSCAN = `https://etherscan.io/address/${WZEUS_ADDRESS}`;

/** What a person typed, in base units, or null when it is not a positive amount. */
export function parseAmount(text: string, decimals: number): bigint | null {
  const t = text.trim().replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(t)) return null;
  const [whole, frac = ''] = t.split('.');
  if (frac.length > decimals) return null;
  const value = BigInt(whole + (frac + '0'.repeat(decimals)).slice(0, decimals));
  return value > BigInt(0) ? value : null;
}

const UNITS: Array<[number, string]> = [
  [1e12, 'T'],
  [1e9, 'B'],
  [1e6, 'M'],
  [1e3, 'K'],
];

/** A balance in a few characters: 12.35K, 4.21B. */
export function formatTokens(value: bigint, decimals: number): string {
  const n = Number(value) / 10 ** decimals;
  if (n === 0) return '0';
  for (const [size, unit] of UNITS) {
    if (n >= size) return `${trim((n / size).toFixed(2))}${unit}`;
  }
  return trim(n.toFixed(2));
}

const trim = (s: string) => s.replace(/\.?0+$/, '');

/** Base units back to the text a person would type, for the MAX button. */
export function toInput(value: bigint, decimals: number): string {
  const s = value.toString().padStart(decimals + 1, '0');
  const whole = s.slice(0, s.length - decimals);
  const frac = s.slice(s.length - decimals).replace(/0+$/, '');
  return frac ? `${whole}.${frac}` : whole;
}
